<template>
  <div>
    <div class="row">
      <div class="sidebarContainer">
        <div class="sidenav column">
          <div class="logo">
            <img
              src="../assets/Icons/SG-logo.svg"
              alt=""
              style="background-color: #2b2b2c"
            />
          </div>
          <ul id="list">
            <li class="list--item">
              <span
                :class="[
                  currentPage.includes('home')
                    ? activeClass
                    : 'deactivatedPage',
                  'activatePage'
                ]"
              ></span>
              <router-link to="/home" tag="li" v-on:click.native="selectedPage"
                >Home</router-link
              >
            </li>
            <li class="list--item">
              <span
                :class="[
                  currentPage.includes('skillCourt')
                    ? activeClass
                    : 'deactivatedPage',
                  'activatePage'
                ]"
              ></span>
              <router-link to="/skillCourt" tag="li">Skill Court </router-link>
            </li>
            <li class="list--item">
              <span
                :class="[
                  currentPage.includes('users')
                    ? activeClass
                    : 'deactivatedPage',
                  'activatePage'
                ]"
              ></span>
              <router-link to="/users" tag="li">Users</router-link>
            </li>
            <!-- <li class="list--item">
          <span :class="[currentPage.includes('login')? activeClass : 'deactivatedPage' ,'activatePage' ]"></span>
          <router-link to="/login" tag="li" >Log in</router-link>
        </li> -->
          </ul>
        </div>
      </div>
      <div class="headerContainer">
        <div class="header">
          <div class="Header-block-element">
            <select
              class="court-select"
              @change="selectCourt"
              name=""
              id=""
              style="width: 260px;height: 32px;"
              ><option
                v-for="court in getUserCourts"
                :key="court.id"
                :value="JSON.stringify(court)"
                >{{ court.name }}</option
              >
            </select>
            <!-- <router-link to="/signup" class="block-element block-element__mail">
        <img src="../assets/Icons/mail.png" alt=""/></router-link> -->
            <a
              class="block-element block-element__mail"
              href="mailto:info@smartGoals.nl"
              ><img src="../assets/Icons/mail.png" alt=""
            /></a>

            <!-- <p class="block-element block-element__name">{{ this.$store.state.currentUser.username }}</p> -->

            <img
              class="block-element block-element__pic"
              :src="takeCurrentUser.profile_picture_path"
              alt=""
              style="
                width: 50px;
                height: 50px;
                vertical-align: middle;
                border-radius: 50%;
              "
            />

            <p class="block-element block-element__name">
              {{ takeCurrentUser.username }}
            </p>
            <select
              class="block-element block-element__list"
              v-model="log_out_model"
            >
              <option value="/logout">Log out</option>
              <!-- <option value="lastWeek" >Edite</option> -->
            </select>
          </div>
        </div>

        <div class="pages column"><router-view /></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_SELECTED_COURT } from "../store/mutations.type";
export default {
  data() {
    return {
      log_out_model: "",
      tempOptions: {
        id: 2,
        name: "Tepm option court"
      },
      activeClass: "activatePage"
    };
  },
  watch: {
    log_out_model() {
      this.logout();
    }
  },
  computed: {
    ...mapGetters(["takeCurrentUser", "getUserCourts", "getSelectedCourt"]),
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
    async logout() {
      localStorage.removeItem(this.$store.state.token);
      this.$store.commit("logOut");

      location.reload();
    },
    selectedPage() {},
    selectCourt(e) {
      let selectedCourt = JSON.parse(e.target.value);

      this.$store.commit(SET_SELECTED_COURT, selectedCourt);
    }
  }
};
</script>

<style scoped lang="scss">
.pages {
  overflow-x: hidden;
  height: calc(100vh - 88px);
}

.headerContainer {
  display: flex;
  flex-direction: column;
}

.header {
  font-family: Montserrat-SemiBold;
  background-color: #2b2b2c;
  color: #ffffff;
  overflow: hidden;
  height: 88px;
  width: 100%;
  /* background-color: red; */
}

.Header-block-element {
  background-color: #2b2b2c;
  float: right;
  /* width: calc(100% - 10px); */
  //width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin: 10px 20px;
  column-gap: 16px;
  /* text-align: right; */

  // padding: 10px 0 0 20px;
}

.block-element {
  background-color: #2b2b2c;
  margin: 24px 5px 15px 0;
}
.block-element__pic {
  display: inline;
  background-color: yellow;

  margin: 8px 8px 10px 15px;
}
.block-element__name {
  margin: 24px 8px 32px 5px;
}
.block-element__list {
  margin: 24px 0;
  width: 20px;
  cursor: pointer;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}

.sidebarContainer {
  width: 215px;
  float: left;
  overflow: hidden;
  z-index: 1;
}

.sidenav {
  height: 100vh;
  //width: 100% !important;
  //position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  top: 0;
  background-color: #2b2b2c;
  overflow-x: hidden; /* Disable horizontal scroll */

  box-shadow: 3px 3px 6px 0 rgba(8, 8, 8, 0.25);

  /* text-align: right; */
}

.logo {
  background-color: #2b2b2c;
  width: 150px;
  height: 33px;

  img {
    width: 150px;
    height: 33px;
    margin: 20px 0 19px 25px;
  }
}

ul {
  margin: 88px 192px 0 20px;
  background-color: #2b2b2c;
  font-family: Montserrat-SemiBold;
  padding: 0;
  width: 199px;
}

.list--item {
  display: inline-block;
}

li {
  margin: 0 0 32px 0;
  /* text-decoration: none; */
  font-size: 18px;
  display: inline;
  background-color: #2b2b2c;
  width: 200px;
  // opacity: 0.6;
  color: #afafaf;
  font-family: Montserrat-Medium;
  font-weight: normal;
}
.sidenav li:hover {
  cursor: pointer;
  opacity: 1;
}
.activatePage {
  color: red;
  display: inline-block;
  visibility: visible;
  width: 13px;
  height: 13px;
  background-color: #f7941e;
  margin: 0 16px 0 0;
}

.deactivatedPage {
  visibility: hidden;
}

li.router-link-active {
  opacity: 1;
}

li.router-link-exact-active {
  opacity: 1;
  color: #ffffff;
}

.court-select {
  align-self: center;
  font-size: 16px;
}
</style>
